export default __webpack_public_path__ + "static/img/16613 1.247a5e5.png";